import React, { Suspense } from "react";

import { Route } from "react-router-dom";
// import { LinearProgress } from "@mui/material";
//import { isMobile } from "react-device-detect";

import ErrorBoundary from "../components/ErrorBoundary";
import SuspenseLoader from "../components/SuspenseLoader";
//import SbFooter from "../components/Footer/SbFooter";

export const suspenseWrapper = (Component) => {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <ErrorBoundary>
        <Component />
      </ErrorBoundary>
    </Suspense>
  );
};

export const routesBuilder = (routes, version) => {
  const privateRoutes = [];
  const nonPrivateRoutes = [];
  routes.forEach((item) => {
    if (item.private && item.version === version) {
      privateRoutes.push(
        <Route
          key={item.path}
          path={item.path}
          element={suspenseWrapper(item.component)}
        />
      );
      return;
    }
    if (!item.private && item.version === version) {
      nonPrivateRoutes.push(
        <Route
          key={item.path}
          path={item.path}
          element={suspenseWrapper(item.component)}
        />
      );
      return;
    }
  });
  return [privateRoutes, nonPrivateRoutes];
};
